/** @jsx jsx */
import { jsx } from 'theme-ui';
import {
  RadioInput as styles,
  RadioInputReplacement,
} from './RadioButton.styles';
import { useField } from 'formik';
import React from 'react';

/**
 * A simple RadioInput implementation where you can set the name and value property. Basic styling is also possible from outside
 * to set appropriate margins.
 */
export default function RadioInput({ name, value, className }) {
  const [field] = useField(name);

  return (
    <>
      <input
        {...field}
        sx={{ ...styles, variant: 'layout.Form.RadioInput' }}
        type="radio"
        name={name}
        value={value}
        checked={value == field.value}
      />
      <span
        sx={{
          ...RadioInputReplacement,
          variant: 'layout.Form.RadioInputReplacement',
        }}
        className={className}
      ></span>
    </>
  );
}
